import DropDown from './drop-down';

class DropDownInput extends DropDown {
  constructor() {
    super();

    this.checkValue = this.checkValue.bind(this);
    this.dropDownInput = null;
  }

  checkValue() {
    this.dropDownInput = this.querySelectorAll('.js-drop-down-input');
    this.sortTitle = this.querySelector('.sort_method');

    if (!this.dropDownInput.length) return;

    this.dropDownInput.forEach(checkbox => {
      checkbox.addEventListener('change', () => {  
        this.dropDownInput.forEach(input => {
          if (input !== checkbox) {
            input.removeAttribute('checked');
          }
        });
  
        if (checkbox.checked) {
          if (this.sortTitle) {
            this.sortTitle.textContent = checkbox.getAttribute("data-name") || checkbox.value;
          }

          checkbox.setAttribute('checked', 'checked');
        } else {
          checkbox.removeAttribute('checked');
        }
      });
    });
  }

  connectedCallback() {
    super.connectedCallback();
    this.checkValue();
  }
}

const init = () => {
  if (!customElements.get("custom-dropdown-input")) {
    customElements.define('custom-dropdown-input', DropDownInput);
  }
};

init();